import { Headers } from '@angular/http';
import { environment } from 'environments/environment';
import { WorkflowType } from 'app/clients/client/header/onboard-request.model';

/**
 * Constants to be used within the application.
 */
export class ConstantsService {
    public static IS_LOCALHOST = window.location.host.match(/localhost/i);
    // @todo move to git ignored env file + add variable to disable tawk
    public static TRUST_URL = '/';
    public static LOCAL_TOMCAT_HOST = '/';
    public static LOCAL_ANGULAR_HOST = '/';

    public static APP_BE_URL = environment.APP_BE_URL; // URL to Trust api

    public static AUTH_BE_URL = environment.AUTH_BE_URL; // URL to Trust api

    public static APP_HOME_URL = ConstantsService.TRUST_URL;

    public static LOGIN_URL = environment.LOGIN_URL;

    public static WORKFLOW_URL = environment.WORKFLOW_URL;

    public static NEW_CAF_URL = environment.CAF_URL;

    public static POST_LOGIN_URL = '/#/dashboard';

    public static COOKIE_PATH = environment.COOKIE_PATH;

    public static TIMEOUT = 50000; // Increasing timeout as request are failing from rest app side.
    public static LOCAL_STORAGE_TIMEOUT = Date.now() + 1000 * 60 * 60 * 24;
    public static MENU_LOGIN_NAME_MAX_LENGTH = 15;

    // HTTP Header constants.
    public static FORM_CONTENT_TYPE_HEADER = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });


    // REST endpoints relative from the rest context
    public static APP_LOGIN = '/users/authenticate';
    public static APP_LOGOUT = '/users/logout/'; // session id will be appended at the end.
    public static PASSWORD_RESET = '/users/resetpassword';
    public static PASSWORD_RECOVERY_MAIL = '/users/forgotpassword';
    public static ALL_APPLICATION_TYPES_URL = '/admin/applicationtype/all';
    public static APPLICATION_TYPE_URL = '/admin/applicationtype/';
    public static LEGAL_STRUCTURE_URL = '/admin/applicationtype/LegalStructure';
    public static ADD_APPLICATION_TYPE_URL = '/admin/applicationtype';
    public static ADD_ORGANISATION_URL = '/relationentity/organisation';
    public static ADD_PERSON_URL = '/relationentity/person';
    public static SAVE_TIMESHEET = '/timekeeping/timesheet';
    public static LOAD_CLIENT_SUGGESTIONS = '/search';
    public static CHANGE_PASSWORD_URL = '/users/changepassword';
    public static USER_PREFERENCES_URL = '/users/userpreferences';
    public static WARM_UP_SERVICE_RETRIES = 3;
    public static PERSON_DETAILS_PAGE = '#!/personDetails';
    public static ORG_DETAILS_PAGE = '#!/companyDetails';
    public static VERIFY_SESSION = '/users/verifysession/';
    public static GET_USER_PREFERENCES = '/users/userpref/fetch/';
    public static AUTO_DETECT_EWS_URL = '/emails/detectewsurl?';
    public static ENTITY_ARCHIVAL_URL = '/relationentity/archiveentity';
    public static ENTITIES_ARCHIVAL_URL = '/relationentity/archiveentities';
    public static ENTITIES_WITHOUT_RELATIONS_URL = '/relationentity/entities-without-relations';

    public static SURVEY_TEMPLATE = '/surveymanagement/surveytemplate';

    public static IMPORT_CLIENT_MAPPING_FILTERS = '/documents/importclient/mappingfilters';
    public static IMPORT_CLIENT_MAPPING_INSTRUCTIONS = '/documents/importclient/processmappingfile';

    public static SURVEY_CONFIG = '/surveymanagement/surveyconfig';
    public static LOAD_ENTITY_TYPES = '/surveymanagement/entitytypes';

    public static SURVEY_QUESTION_TEMPLATE = '/surveymanagement/questiontemplate';
    public static SURVEY_QUESTION_INSTANCE_ANSWERED = '/surveymanagement/questioninstance/{questionTemplateId}/answered';
    public static SURVEY_QUESTION_INSTANCE_ANSWERED_WITH_OPTION = ConstantsService.SURVEY_QUESTION_INSTANCE_ANSWERED + '/options/{opTemplateId}';
    public static SURVEY_QUESTION_INSTANCE_CLEAR_RESPONSE = '/surveymanagement/questioninstance/{questionInstanceIds}/clearResponse';
    public static SURVEY_QUESTION_INSTANCE_MOVE_RESPONSE = '/surveymanagement/questioninstance/moveresponse/{sourceQuestionTemplateId}/{targetQuestionTemplateId}';

    public static USERS = '/users';

    public static LOAD_PROCESS_LIST = '/process';
    public static LOAD_PROCESS_TASK_LIST = '/process/tasks';
    public static UPLOAD_PROCESS_FILE_URL = '/process/processesfile';

    public static RULE_GROUP = '/rules/rulegroups';
    public static RULE_GROUP_MAPPING = '/rules/rulemappings';
    public static RULE = '/rules';
    public static RULE_VALIDATE = '/rules/validate';
    public static RULE_PARAM = '/rules/parameters';
    public static RULE_PARAM_DATATYPE = '/rules/parameters/datatypes';

    public static UPLOAD_MT940_FILE_URL = '/files/mt940files';

    // @todo This URL is to be changed once REST is available.
    public static TASK_GUIDE_UPDATE_URL = '/process/taskguide';

    // Cookie parameter constants.
    public static COOKIE_LOGIN_TOKEN = 'loginToken';
    public static COOKIE_SESSION_ID = 'sessionId';
    public static COOKIE_LOGIN_NAME = 'loginName';
    public static COOKIE_LOGIN_USER_NAME = 'loginUserNames';
    public static COOKIE_ACCESS_TOKEN = 'accessToken';
    public static COOKIE_USER_ROLE = 'userRole';
    public static COOKIE_REDIRECT_URL = 'redirectUrl';
    public static COOKIE_COMPLIANCE_OFFICER = 'coff';

    // Iframe constants.
    public static IFRAME_ORG_FIELD_ID = 'orgIFrameFieldId';
    public static IFRAME_PERSON_FIELD_ID = 'personIFrameFieldId';
    public static ENT_CUR_TYPE = '_ent_t';
    public static ENT_CUR_ID = '_ent_i';


    // Home page Iframe URL. Only Session ID is to be appended to make it work.
    public static HOME_PAGE_IFRAME_URL = ConstantsService.APP_HOME_URL + '#session_login;session_id=';
    public static SANC_LOGS_IFRAME_SUFFIX = '#sanctionMatchingLog';
    public static ARCHIVAL_IFRAME_SUFFIX = '#archival';
    public static GROUP_IFRAME_SUFFIX = '#groupManagement';
    public static SURVEY_CONFIG_IFRAME_SUFFIX = '#surveyManagement';
    public static TENANT_CONFIG_IFRAME_SUFFIX = '#tenantConfiguration';
    public static SURVEYTEMPLATE_IFRAME_SUFFIX = '#questionnaires';
    public static APP_ACTIVITY_IFRAME_SUFFIX = '#applicationActivity';
    public static CONFIG_RULES_IFRAME_SUFFIX = '#createRule';
    public static CONFIG_RULE_GRP_MAPPING_IFRAME_SUFFIX = '#ruleGroupFunctionalityMapping';
    public static RULE_APP_PARAMS_IFRAME_SUFFIX = '#ruleAppParam';
    public static LIST_PROCESSES_IFRAME_SUFFIX = '#processDefinitions';
    public static IMPORT_CLIENT_DATA_IFRAME_SUFFIX = '#importclientdata';
    public static SERVICES_IFRAME_SUFFIX = '#clientServicesConfig';
    public static EXACT_ONLINE_POP_UP_URL = 'https://start.exactonline.nl/api/oauth2/auth?'
        + 'client_id={bedee9a8-ae63-40a1-9e76-67c1c0284c17}&redirect_uri='
        + 'https://www.governance.cc/trust/oauth2redirect&response_type=code';

    // Image Paths
    public static DEFAULT_PERSON_MALE_LOGO = 'assets/images/male_profile.png';
    public static DEFAULT_PERSON_FEMALE_LOGO = 'assets/images/female_profile.png';
    public static DEFAULT_ORG_LOGO = 'assets/images/org_profile.png';

    // Servlet URLs (relative to the trust backend url)
    public static SERVLET_LOGO_UPLOAD = '/srv/companyLogoUpload';
    public static SERVLET_RELATION_UPLOAD = '/srv/importRelationships';
    public static PRINT_REPORT_SERVLET = '/srv/printReport';
    public static PROCESS_IMAGE_SERVLET = '/srv/processImage';
    public static PROCESS_IMAGE_DEFINITION_SERVLET = '/srv/processDefinitionImage';
    public static DOWNLOAD_DOCUMENT = '/srv/documentDownload';
    public static PARAM_ISI_2017 = '?reportContext=isiReport2016&fileName=ISI-Formulier_2017.xlsx';
    public static PARAM_ISI_SUB_2017 = '?reportContext=isiReport2016sub&entityId=ENTID&fileName=ISI_REPORT_31122017_REPORTNAME.xlsx';
    public static PARAM_ISI_2018 = '?reportContext=isiReport2018&fileName=ISI-Formulier_2018.xlsx';
    public static PARAM_ISI_SUB_2018 = '?reportContext=isiReport2018sub&entityId=ENTID&fileName=ISI_REPORT_31122018_REPORTNAME.xlsx';
    public static PARAM_ISI_2019 = '?reportContext=isiReport2019&fileName=ISI-Formulier_2019.xlsx';
    public static PARAM_ISI_SUB_2019 = '?reportContext=isiReport2019sub&entityId=ENTID&fileName=ISI_REPORT_31122019_REPORTNAME.xlsx';
    public static PARAM_ISI_2020 = '?reportContext=isiReport2020&fileName=ISI-Formulier_2020.xlsx';
    public static PARAM_ISI_SUB_2020 = '?reportContext=isiReport2020sub&entityId=ENTID&fileName=ISI_REPORT_31122020_REPORTNAME.xlsx';
    public static PARAM_ISI_2021 = '?reportContext=isiReport2021&fileName=ISI-Formulier_2021.xlsx';
    public static PARAM_ISI_SUB_2021 = '?reportContext=isiReport2021sub&entityId=ENTID&fileName=ISI_REPORT_31122021_REPORTNAME.xlsx';
    public static PARAM_ISI_2022 = '?reportContext=isiReport2022&fileName=ISI-Formulier_2022.xlsx';
    public static PARAM_ISI_SUB_2022 = '?reportContext=isiReport2022sub&entityId=ENTID&fileName=ISI_REPORT_31122022_REPORTNAME.xlsx';
    public static PARAM_ISI_2023 = '?reportContext=isiReport2023&fileName=ISI-Formulier_2023.xlsx';
    public static PARAM_ISI_SUB_2023 = '?reportContext=isiReport2023sub&entityId=ENTID&fileName=ISI_REPORT_31122023_REPORTNAME.xlsx';
    public static PARAM_ISI_2024 = '?reportContext=isiReport2024&fileName=ISI-Formulier_2024.xlsx';
    public static PARAM_ISI_SUB_2024 = '?reportContext=isiReport2024sub&entityId=ENTID&fileName=ISI_REPORT_31122024_REPORTNAME.xlsx';
    public static PARAM_ISI_2025 = '?reportContext=isiReport2025&fileName=ISI-Formulier_2025.xlsx';
    public static PARAM_ISI_SUB_2025 = '?reportContext=isiReport2025sub&entityId=ENTID&fileName=ISI_REPORT_31122025_REPORTNAME.xlsx';




    // *** Component routes ***

    // Dashboard
    public static DNB_DASHBOARD_COMPONENT_ROUTE = '/dnbdashboard';
    public static DASHBOARD_COMPONENT_ROUTE = '/dashboard';

    // Clients
    public static CLIENTS_OVERVIEW_COMPONENT_ROUTE = '/clients';
    public static CLIENT_REVIEW_COMPONENT_ROUTE = '/reviews';

    // Admin
    public static ADMIN_USERS_COMPONENT_ROUTE = '/users';
    public static ADMIN_GROUP_COMPONENT_ROUTE = '/groups';
    public static ADMIN_RULES_COMPONENT_ROUTE = '/rules';
    public static APPLICATION_ACTIVITY_COMPONENT_ROUTE = '/appactivity';
    public static IMPORT_CLIENT_COMPONENT_ROUTE = '/importclient';
    public static ADMIN_SERVICES_COMPONENT_ROUTE = '/services';

    // Other
    public static BANK_STATEMENT_BATCH_COMPONENT_ROUTE = '/bank-statements-batch';
    public static PENDING_TRANSACTIONS_OVERVIEW_COMPONENT_ROUTE = '/pending-transactions-overview';
    public static PENDING_HITS_OVERVIEW_COMPONENT_ROUTE = '/pending-hits-overview';
    public static PAYMENTS_COMPONENT_ROUTE = '/payments';
    public static WORKFLOW_COMPONENT_ROUTE = '/workflow';
    public static ARCHIVAL_MANAGEMENT_COMPONENT_ROUTE = '/archivals';
    public static BANK_INSTITUTION_MANAGEMENT_COMPONENT_ROUTE = '/bankinstitutions';
    public static INTEGRATION_MANAGEMENT_COMPONENT_ROUTE = '/integrations';
    public static PROCESS_TASK_MANAGEMENT_COMPONENT_ROUTE = '/processes';
    public static SANCTION_LOGS_COMPONENT_ROUTE = '/sanctionlogs';
    public static SURVEY_MANAGEMENT_COMPONENT_ROUTE = '/surveys';
    public static TENANT_CONFIGURATION_COMPONENT_ROUTE = '/tenantconfiguration';
    public static MAIN_ISI_COMPONENT_ROUTE = '/isireport';
    public static MAIN_SECOND_ISI_COMPONENT_ROUTE = '/newreport';
    public static IMPORTS_IFRAME_SUFIX= '/imports';
    public static TRANSACTION_PROFILE_EXPORT_COMPONENT_ROUTE = '/transaction-profiles-export';



    // *** API Endpoints ***

    // Dashboard
    public static DNB_CLIENTS_LIST = '/clients/dnb';
    public static MY_CLIENTS_LIST = '/clients/mine';
    public static MY_ONBOARDINGS_LIST = '/clientworkflow/activeonboardings';
    public static MY_REVIEWS_LIST = '/clientworkflow/activereviews';
    public static NEWS_ENDPOINT = '/news';

    // Clients & Organisations
    public static CLIENTS_ENDPOINT = '/clients';
    public static CLIENT_REVIEWS_ENDPOINT = '/clientworkflow/reviews';
    public static ORGANISATION_ENDPOINT = '/organisations';
    public static CLIENTS_STATES_ENDPOINT = '/states';

    // Tasks
    public static TASKS_ENDPOINT = '/tasks';
    public static TASK_DELEGATE_ENDPOINT = '/tasks/delegate';
    public static TASK_SUBMIT_ENDPOINT = '/tasks/submit';
    public static TASK_RESOLVE_ENDPOINT = '/tasks/resolve';
    public static TASK_COMMENT_ENDPOINT = '/tasks/comment';
    public static TASK_GUIDE_ENDPOINT = '/tasks/taskguide';
    public static TASK_SUBMIT_CHOICE_ENDPOINT = '/tasks/changestatus';
    public static MY_TASKS_ENDPOINT = '/tasks/mine';
    public static ACTIVE_WORKFLOWS = '/entity/activeworkflow';
    public static CANCEL_WORKFLOW = '/process';


    // FINANCE
    public static BANK_INSTITUTIONS_ENDPOINT = '/bank/institutions';
    public static BANK_INSTITUTIONS_ACCOUNTS_ENDPOINT = '/bank/institutions/accounts';
    public static BANK_STATEMENT_DETAILS_ENDPOINT = '/documents/bank-accounts';
    public static SAVE_BANK_STATEMENT_DOCUMENT = '/documents/bank-statement';
    public static SAVE_BANK_STATEMENT_JSON_DATA = '/documents/bank-statement';
    public static BANK_ACCOUNTS_ENDPOINT = '/bank/accounts';
    public static BANK_STATEMENT_BATCH_UPLOAD = '/bank-statement/batch/upload';
    public static BANK_STATEMENT_BATCH_LIST = '/bank-statement/batch/list';
    public static BANK_STATEMENT_BATCH_MATCH = '/bank-statement/batch/match';
    public static BANK_STATEMENT_BATCH_CONFIRM = '/bank-statement/batch/confirm';
    public static BANK_STATEMENT_BATCH_FIND_ACCOUNT = '/bank-statement/batch/find-account';
    public static BANK_STATEMENT_BATCH_FIND_ACCOUNT_HOLDERS = '/bank-statement/batch/find-account-holders';
    public static BANK_STATEMENT_BATCH_BACKFILL_ACCOUNT_OWNER = '/bank-statement/batch/backfill-account-owner';
    public static BANK_STATEMENT_BATCH_BACKFILL_STATEMENT_DATES = '/bank-statement/batch/backfill-statement-dates';
    public static BANK_STATEMENT_BATCH_TIMELINE = '/bank-statement/batch/timeline';
    public static BANK_STATEMENT_BATCH_CLEANUP_PREVIEW = '/bank-statement/batch/cleanup/preview';
    public static BANK_STATEMENT_BATCH_CLEANUP = '/bank-statement/batch/cleanup';
    // @todo refactor end-points for payment management
    public static FETCH_PAYMENTS = '/paymentmanagement/payments';
    public static SAVE_PAYMENT = '/paymentmanagement/payment/save';
    public static DELETE_PAYMENT = '/paymentmanagement/payment/delete';
    public static SYNC_CITCO = '/paymentmanagement/synccitco';

    // Admin
    public static CURRENCIES_ENDPOINT = '/admin/currencies';
    public static INTEGRATIONS_ENDPOINT = '/integrations';

    // MWA: note, the below constants are not using the correct naming
    // scheme, these will be refactored to xxx_ENDPOINT

    // Other
    public static ORGANISATION_DETAILS = '/relationentity/organisation';
    public static UPDATE_REVIEW_DATE = '/clients/reviewdate';
    public static OFFBOARD_CLIENT = '/clients/offboardclient';
    public static LIST_SYSTEM_DIVISIONS = '/clients/systemdivisions';
    public static SET_SYSTEM_DIVSION = '/clients/systemdivisions';

    // RelationEntity route helpers (UI deep-linking)
    public static RELATION_ENTITY_ROUTE_DETAILS = '/relationentity/entity';

    // Risk Details
    public static RISK_PROFILE_SCORE = '/riskprofiles/scores';
    public static RISK_PROFILE = '/riskprofiles';

    // Onboard Wtt Client URL
    public static ONBOARD_ORG_URL = '/clients/onboardorg';

    // Person Header URLs
    public static PERSON_DETAILS = '/relationentity/persons';
    public static UPDATE_PERSON = '/relationentity/persons';

    // Searching
    public static CLIENT_SEARCH = '/clients/search';
    public static HEADER_SEARCH = '/search';
    public static GOOGLE_SEARCH = '/search/google';
    public static ARCHIVAL_ENTITY_SEARCH = '/search';
    public static ADD_RELATION_SEARCH = '/search';



    //Tenant Offices

    public static TENANT_OFFICE = '/tenantoffices';
    public static TENANT_CONFIGURATION = '/tenantconfigurations';
    public static TENANT_SCREENING_REGISTER_ALL = '/tenantconfigurations/screening/register-all-entities';
    public static TENANT_SCREENING_CLEANUP_PREVIEW = '/tenantconfigurations/screening/cleanup/preview';
    public static TENANT_SCREENING_CLEANUP = '/tenantconfigurations/screening/cleanup';
    public static TENANT_OFFICE_HEAD_OFFICE = '/tenantoffices/headoffice';
    public static DOCUMENT_MIGRATION_MIGRATE = '/documents/migration/migrate';
    public static DOCUMENT_MIGRATION_VERIFY = '/documents/migration/verify';
    public static DOCUMENT_MIGRATION_STATUS = '/documents/migration/status';
    public static DOCUMENT_MIGRATION_VERIFY_STATUS = '/documents/migration/verify/status';
    public static DOCUMENT_MIGRATION_TEST = '/documents/migration/test';

    // Groups
    public static GROUP = '/users/groups';

    // Task Guide default text.
    public static TASK_GUIDE_DEFAULT_TEXT = 'Geen handboek informatie beschikbaar bij deze taak';

    // List Client Services.
    public static LIST_CLIENT_SERVICES = '/clients/services/client';
    public static PROVIDED_CLIENT_SERVICES = '/clients/services/provided';
    public static SERVICES_DESCRIPTION = '/clients/services/provided/description';
    public static DOCUMENTS_DESCRIPTION = '/clients/services/documentdesc';

    //Entity
    public static ENTITY = '/entity';

    // Contact details.
    public static LIST_ORG_CONTACT_DETAILS = '/entity/communication/org';
    public static LIST_PERSON_CONTACT_DETAILS = '/entity/communication/person/fetch';
    public static ADD_CONTACT = '/entity/communication';
    public static DELETE_ORG_CONTACT = '/entity/communication';

    // URL details for Address Information.
    public static SAVE_DELETE_ADDRESS_INFORMATION = '/entity/location';
    public static LIST_ORG_ADDRESS_INFORMATION = '/entity/location/org';
    public static LIST_PERSON_ADDRESS_INFORMATION = '/entity/location/person';

    // URL details for Activities.
    public static LIST_ORG_ACTIVITY_INFORMATION = '/relationentity/activity';
    public static GET_ACTIVITIES = '/search/activities';
    public static ADD_ACTIVITY = '/relationentity/activity';
    public static UPDATE_ACTIVITY_CATEGORY = '/relationentity/activity/category';
    public static UPDATE_ACTIVITY_CATEGORY_SUMMARY = '/relationentity/activity/summary';

    // Entities General Information Services.
    public static ENTITY_ORG_GENERAL_INFO_SERVICES = '/entity/summary/generalinformation/org';
    public static ENTITY_PERSON_GENERAL_INFO_SERVICES = '/entity/summary/generalinformation/person';

    // Email Tab
    public static EMAIL = '/emails';

    // Fetch documents details.
    public static FETCH_DOCUMENT_BYDOCTYPE = '/documents/bydoctype';

    // Document Tab Services.
    public static DOCUMENT_LABELS = '/documents/labels';
    public static DOCUMENT = '/documents';
    public static SEARCH_DOCUMENTS_BY_NAME_AND_CONTENT = ConstantsService.DOCUMENT + '/searchDocument';
    public static DOCUMENT_UPLOAD = '/documents/upload';
    public static DOCUMENT_REUPLOAD = '/documents/reupload';
    public static DOCUMENT_EXTRACT_TYPE_TAGS = '/documents/extract-type-tags';

    // Monitoring Elaboration Description Services.
    public static MONITORING_ELABORATION_INFO_SERVICES = '/monitoring/desc';
    public static MONITORING_SANCTION_MATCH_SERVICES = '/monitoring/sanctions';
    public static MONITORING_PEP_MATCH_SERVICES = '/monitoring/pep';
    public static RESOLVE_SANCTION = '/monitoring/sanctions/resolution';
    public static RESOLVE_BAD_PRESS = '/monitoring/badpress/resolution';
    public static RESOLVE_PEP = '/monitoring/pep/resolution';

    // Relationships
    public static RELATIONSHIP = '/relation';
    public static RELATIONSHIP_ENTITY = '/relationentity';
    public static GET_EXECUTIVE_SUMMARY = '/executivesummary';
    public static REVERSE_RELATIONSHIP = ConstantsService.RELATIONSHIP + '/reverse/';
    public static UBO_RELATIONSHIP = ConstantsService.RELATIONSHIP + '/ubo';
    public static EXECUTIVE_SUMMARY = '/relationentity/executivesummary';

    // RelationShip Diagram
    public static RELATIONSHIP_DIAGRAM = '/diagrams';

    // Transaction Profile.
    public static AGREEMENTS = '/transactionprofile/agreement';
    public static TRANSACTION = '/transactions';
    public static TRANSACTION_STATUS = '/transactions/status';
    public static RUN_RULES_FOR_PENDING_TRANSACTIONS = '/transactions/run-rules';
    public static PENDING_TRANSACTIONS_EXPORT = '/transactions/clients-with-pending/export';
    public static CLEANUP_TRANSACTION_RECORDS = '/transactions/cleanup';
    public static ESCALATE_TRANSACTION = '/transactions/escalate';
    public static CHECK_NAME_MATCH = '/transactions/check-name-match';
    public static SEARCH_TRANSACTIONS = '/transactions/search';
    public static TEST_TRANSACTION_RULE_MATCH = '/transactions/test-rule-match';
    public static CREATE_TRANSACTION_PROFILE_FROM_RECORD = '/transactions/create-profile';
    public static RIGHTS = '/transactionprofile/rights';
    public static RISKS = '/transactionprofile/risks';
    public static OBLIGATIONS = '/transactionprofile/obligations';
    public static ALL_TRANSACTION_RULES = '/transactionprofile/agreement';
    public static SURVEY_DETAILS = '/transactionprofile/entity';
    public static AGREEMENT_DOCUMENTS = '/transactionprofile/agreements';
    public static TRANSACTION_RULE = '/transactionprofile/txnrule';
    public static ADD_TRANSACTION_RULE = '/transactionprofile/client';
    public static GET_TRANSACTION_RULES = '/transactionprofile/txnrule/client';
    public static TRANSACTION_COUNTER_PARTY = '/relation';
    public static DOCUMENTS = '/documents';
    public static GET_TRANSACTION_RULE = '/transactionprofile/client';
    public static BANK_ACCOUNTS = '/bank/accounts/all';
    public static AGREEMENT_DOCUMENT_UPLOAD = '/transactionprofile/agreement';
    public static WORKFLOWTYPE_MAP: Map<WorkflowType, string> = new Map(
        [
            [WorkflowType.WF_ONBOARD_WTT, 'Process_ClientAcceptanceWTT'],
            [WorkflowType.WF_ONBOARD_WWFT, 'Process_ClientAcceptanceWWFT'],
            [WorkflowType.WF_OFFBOARD, 'Process_ClientOffboarding'],
            [WorkflowType.WF_PEP, 'PEP_Process'],
            [WorkflowType.WF_REVIEW, 'ReviewProcess'],
            [WorkflowType.WF_RISK_PROFILE, 'RiskProfileProcess'],
            [WorkflowType.WF_SANCTIONMATCH, 'Process_sanctionmatch'],
            [WorkflowType.WF_TRANSACION_ACCEPTANCE, 'Process_TransactionProfileAcceptance'],
            [WorkflowType.WF_TRANSACTION_EDIT, 'Process_TransactionProfileEdit'],
            [WorkflowType.WF_TRANSACTION_OUT_OF_ANY_PROFILE, 'Process_TransactionNotMatchingAnyProfile'],
        ]
    );

    // Audit Tab URLs.
    public static AUDIT = '/journal';

    // Month Short Names Array
    public static MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    public static MONITORING_BAD_PRESS_MATCH_SERVICES = '/monitoring/badpress';
    public static MONITORING_PEP_HISTORY = '/monitoring/pep/history/';
    public static MONITORING_BADPRESS_HISTORY = '/monitoring/badpress/history/';
    public static MONITORING_SANCTIONS_HISTORY = '/monitoring/sanctions/history/';
    public static MONITORING_VERIFY_NOW = '/monitoring/verify/';
    /** Ad-hoc Beamar sanction search by free-text name (header instant screening). */
    public static MONITORING_INSTANT_SCREENING = '/monitoring/instant-screening';
    public static MONITORING_MONITOR = '/monitoring/monitor/';
    public static MONITORING_STATUS = '/monitoring/status/';
    public static MONITORING_ENTITIES_WITH_PENDING_HITS = '/monitoring/entities-with-pending-hits';
    /** Admin-only: delete all open (unresolved) hits for the current tenant. */
    public static MONITORING_DELETE_ALL_OPEN_HITS = '/monitoring/open-hits';
    /** Active clients + related parties + FINAL rule counterparties with tracking status. */
    public static MONITORING_RELATED_ENTITIES_FOR_TRACKING = '/monitoring/related-entities-for-tracking';
    public static MONITORING_SCREENING_HITS_DASHBOARD_MY_CLIENTS =
        '/monitoring/screening-hits-dashboard-for-my-clients';
    public static MONITORING_DELETE_ALL_HITS = '/monitoring/hits/';
    /** Force a Beamar rescreen (sanctions + PEP) of an already-monitored entity. */
    public static MONITORING_RESCREEN = '/monitoring/rescreen/';
    /** Unified open-alerts feed across products. */
    public static MONITORING_ALERTS = '/monitoring/alerts';

    // Survey tab URL's.
    public static SURVEY_DETAIL = '/surveymanagement/questionnaireinstance';

    // Date Format(s)
    /** Date-only display: e.g. 16 Jul 2026 */
    public static DATE_FORMAT = 'dd MMM yyyy';
    /** DateTime display: e.g. 16 Jul 2026 8:08 PM */
    public static DATETIME_FORMAT = 'dd MMM yyyy h:mm a';
    /** ISO date for form pickers / API payloads */
    public static DATE_ISO_FORMAT = 'yyyy-MM-dd';

    // reports
    public static SANCTION_LOGS_ENDPOINT = '/sanctionlogs/';
    public static VALIDATE_DATA_FOR_REPORT = '/reports/isi/verifyData';
    public static MAIN_ISI_REPORT = '/reports/isi/printData';
    public static MAIN_ISI_REPORT_PERSON = '/reports/isi/personInfo';
    public static MAIN_ISI_REPORT_COUNTRY_WISE_PERSON = '/reports/isi/countryWise/person';
    public static MAIN_ISI_REPORT_COUNTRY_ADDRESS = '/reports/isi/countryWise/address';
    public static MAIN_ISI_REPORT_COUNTRY_WISE_ENTITY = '/reports/isi/countryWise/entity';
    public static MAIN_ISI_REPORT_STRUCTURE_WISE_ENTITY = '/reports/isi/structure';
    public static SUB_ISI_REPORT = '/reports/isi/subOffice/printData';
    public static SUB_ISI_REPORT_PERSON = '/reports/isi/subOffice/personInfo';
    public static SUB_ISI_REPORT_COUNTRY_WISE_PERSON = '/reports/isi/subOffice/countryWise/person';
    public static SUB_ISI_REPORT_COUNTRY_WISE_ENTITY = '/reports/isi/subOffice/countryWise/entity';
    public static SUB_ISI_REPORT_STRUCTURE_WISE_ENTITY = '/reports/isi/subOffice/structure';


    // Application Activities
    public static APPLICATION_ACTIVITIES = '/timekeeping/appactivities';


    public static ADD_ADMIN_SERVICE = '/admin/services';
    public static DELETE_ADMIN_SERVICE = '/clients/services/client';

    public static REMOTEMAIL = '/emails/fetch';
    public static IMPORT_EMAIL_DATABASE = '/emails/import/database';

    public static FETCH_ATTACHMENT = '/attachments';

    public static COMPLIANCE_CHECK = '/clients/startcompliancecheck';
    public static CLIENT_REVIEW = '/clients/initclientreview';

    public static REVIEW_DATA_TO_IMPORT_ENDPOINT = '/imports/review-data-to-import';
    public static SAVE_DATA_TO_IMPORT_ENDPOINT = '/imports/transaction-profiles';
    
    // Session-based import endpoints
    public static GET_ACTIVE_SESSION_ENDPOINT = '/imports/session';
    public static CREATE_OR_REPLACE_SESSION_ENDPOINT = '/imports/session';
    public static UPDATE_SESSION_ENDPOINT = '/imports/session';
    public static BUILD_SESSION_FROM_EXCEL_ENDPOINT = '/imports/session/build';
    public static AUTO_MAP_COUNTERPARTIES_ENDPOINT = '/imports/auto-map-counterparties';
    public static AUTO_MAP_CLIENTS_ENDPOINT = '/imports/auto-map-clients';

    // Transaction profile export
    public static TRANSACTION_PROFILE_EXPORT_CLIENTS_ENDPOINT = '/transactionprofile/export/clients';
    public static TRANSACTION_PROFILE_EXPORT_START_ENDPOINT = '/transactionprofile/export/start';
    public static TRANSACTION_PROFILE_EXPORT_STATUS_ENDPOINT = '/transactionprofile/export/status';
    public static TRANSACTION_PROFILE_EXPORT_DOWNLOAD_ENDPOINT = '/transactionprofile/export/download';
    public static TRANSACTION_PROFILE_CLIENT_EXPORT_ENDPOINT = '/transactionprofile/clientexport';

}



// WEBPACK FOOTER //
// ./src/app/services/constants-service.ts